import styled from 'styled-components';
import { colors } from '../../constants';

export const Footnote = styled.p`
    font-size: 14px;
    font-weight: 300;
    width: fit-content;
    color: ${colors.black};
`;
